import React from "react";
import { IStringLocalizer } from "../../../utilities/IStringLocalizer";
import { AiAnswerMetadataTopMessage } from "./aiAnswerMetadata.types";
import { useLocalizer } from "../SupplierAiAgent/hooks/useLocalizer";

interface AIAnswerMetadataTopMessageProps {
    topMessage: AiAnswerMetadataTopMessage;
    localizer?: IStringLocalizer;
}

const AIAnswerMetadataTopMessageComponent: React.FC<AIAnswerMetadataTopMessageProps> = ({ topMessage, localizer }) => {
    const localize = useLocalizer(localizer);
    const {
        message,
        title,
        note,
        noteLabel,
        noteItalicized = false,
        variant = "default"
    } = topMessage;

    const containerClassName = [
        "ai-answer-field__top-message",
        variant === "bom" ? "ai-answer-field__top-message--bom" : ""
    ]
        .filter(className => className.length > 0)
        .join(" ");

    const resolvedNoteLabel = localize(noteLabel ?? "Note");
    const formattedNoteLabel = resolvedNoteLabel.endsWith(":")
        ? resolvedNoteLabel
        : `${resolvedNoteLabel}:`;

    return (
        <div className={containerClassName}>
            {title &&
                <p className="ai-answer-field__top-message-title">{title}</p>
            }

            <p className="ai-answer-field__top-message-body">{message}</p>

            {note &&
                <p className="ai-answer-field__top-message-note">
                    {resolvedNoteLabel &&
                        <>
                            <strong>{formattedNoteLabel}</strong>{" "}
                        </>
                    }
                    {noteItalicized ? <em>{note}</em> : note}
                </p>
            }
        </div>
    );
};

export default AIAnswerMetadataTopMessageComponent;
